import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillingInvoiceManualEditComponent } from './billing-invoice-manual-edit.component';
import { SharedModule } from '../../shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedMaterialModule } from '../../shared-material.module';
import { BillingIvoiceItemManualDialogComponent } from '../../dialogs/billing-ivoice-item-manual-dialog/billing-ivoice-item-manual-dialog.component';
import { BillingInvoiceManualSharedModule } from '../billing-invoice-manual-shared.module';

@NgModule({
  declarations: [
    BillingInvoiceManualEditComponent,
    // BillingIvoiceItemManualDialogComponent,
  ],
  imports: [
    BillingInvoiceManualSharedModule
  ]
  // imports: [
  //   CommonModule,
  //   ReactiveFormsModule,
  //   SharedModule,
  //   SharedMaterialModule
  // ],
  // entryComponents: [
  //   BillingIvoiceItemManualDialogComponent
  // ]
})
export class BillingInvoiceManualEditModule { }
